import { CoreInitiativesFilesName } from './name';
import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getInitiativeFiles } from '@api';

export const coreInitiativesFilesGetAsyncSlice = createGetAsyncSlice({
	name: CoreInitiativesFilesName,
	receive: true,
	request: true,
	requestHandler: getInitiativeFiles,
	retainDataOnRequest: true
});
